import React, { useEffect } from "react";
const MiniHeroSection = ({ data }) => {
  return (
    <section
      className="hero-banner"
      style={{ backgroundImage: `url(${data?.banner_image})` }}
    >
      <div className="hero-container">
        <h1 className="hero-heading">{data?.banner_main_heading}</h1>
        {/* <h3 className='hero-subheading'>Sky47 builds the foundation for Pakistan’s digital future. Our facilities are engineered for scale, resilience, and sovereign control — built to host AI, cloud, and mission-critical enterprise workloads with confidence.</h3> */}
      </div>
    </section>
  );
};

export default MiniHeroSection;
